import { priceDollars } from '../data/catalog'

// Compact destination/plan row used in the Local / Regional tabs on both
// the landing page's "Popular destinations" section and the Destinations
// page. Same shape works for single countries and regional packs — caller
// supplies flag emoji, display name, sub line, and the cheapest price.
export function FeatRow({
  flag,
  name,
  sub,
  fromCents,
  fromLabel,
  currency,
  onClick,
}: {
  flag: string
  name: string
  sub: string
  fromCents: number | null
  fromLabel: string
  currency: string
  onClick: () => void
}) {
  return (
    <div
      className="feat-row"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <div className="flag-tile">{flag}</div>
      <div className="info">
        <div className={`name ${name.length > 26 ? 'name--long' : ''}`}>{name}</div>
        <div className="sub">{sub}</div>
      </div>
      <div className="price">
        {fromLabel && <><span className="from">{fromLabel}</span>{' '}</>}
        <b>{fromCents !== null ? `$${priceDollars(fromCents)}` : '—'}</b>{' '}
        <span className="ccy">{currency}</span>
      </div>
    </div>
  )
}
